<template lang="pug">
  .linegraph
    .linegraph_svgwrapper(ref="svgwrapper")
</template>
<script>
  import {mapGetters, mapState} from 'vuex';
  import * as d3 from 'd3';
  import _ from 'lodash';

  export default {
    data(){
      return {
        svg: undefined,
        linegraph: undefined,
        hoverarea: undefined,
        hoverlines: undefined,
        axis: {
          all: undefined,
          x: undefined,
          y: undefined,
          helper: {
            x: undefined,
            y: undefined
          }
        },
        scale: {
          x: undefined,
          y: undefined
        },
        offset: {
          left: 140,
          right: 140,
          bottom: 60,
          top: 60

        }
      }
    },
    mounted(){
      this.make_svg();
      this.add_hoverarea();
      this.add_axis();
      this.add_hoverlines();
    },
    watch: {
      'size.timestamp': function(){
        //resize
        this.set_scale();
        this.update_graph();
      },
      'linegraph_update_time': function(val, oldVal){
        // update linegraph
        //console.log('watch linegraph_data', val, oldVal);

        this.set_scale();
        if( oldVal > 0){
          this.update_graph();
        }else{
          this.draw_graph();
          this.update_graph();
        }
      },
      'selected.alljapan': function(){
        this.set_scale();
        this.update_graph();
      }
    },
    computed: {
      ...mapState([
        'lang',
        'size',
        'selected',
        'years',
        'linegraph_update_time',
        'linegraph_japan_color',
        'linegraph_color',
        'linegraph_data',
        'linegraph_japan_data',
      ]),
      ...mapGetters([
        'get_years',
        'get_location_data',
      ]),
    },

    methods: {
      /**
       * SVGタグを作り、設置する
       */
      make_svg(){
        this.svg = d3.select(this.$refs.svgwrapper)
          .append('svg')
          .classed('linegraph_svg', true)
      },
      /**
       * 軸描画のためのsvg groupと軸生成ヘルパを作る
       */
      add_axis() {
        this.add_axis_group();
        this.add_axis_helper();
      },
      /**
       * 軸描画のためのsvg groupを作り、設置する
       */
      add_axis_group(){
        this.axis.all = this.svg
          .append('g')
          .classed('linegraph_axis', true)

        this.axis.x = this.axis.all
          .append('g')
          .classed('linegraph_axis_x', true)


        this.axis.y = this.axis.all
          .append('g')
          .classed('linegraph_axis_y', true)
          .attr('transform', 'translate(' + 20 + ',' + 60 + ')')
      },
      /**
       * 軸描画のための軸生成ヘルパを作る
       */
      add_axis_helper(){
        this.axis.helper.x = d3.axisBottom()
          .tickFormat(d3.format("4d"))

        this.axis.helper.y = d3.axisLeft()
          .ticks(6)
      },
      /**
       * マウスホバーイベントを受け取るためのエリアを作り、設置する
       * これは1つのグループであり、この中に、実際にホバーイベントを受け取るrectが配置される。
       */
      add_hoverarea(){
        this.hoverarea = this.svg.append('g')
          .classed('linegraph_hoverarea', true)
          .attr('transform', 'translate(' + this.offset.left + ', ' + 0 + ')')
      },
      /**
       * マウスホバーイベントを受け取るrectを作る
       * 折れ線グラフの点ごとに生成され、対応する点（年）の情報が表示されるようにしている
       */
      add_hoveritems(){
        // データの付加
        let hovers = this.hoverarea.selectAll('rect.linegraph_hoveritem')
          .data(this.get_years)

        // Update要素に対する更新
        hovers.transition();
        this.update_hoveritems(hovers);


        // Enter要素を抽出
        let entered_hovers = hovers.enter()
          .append('rect')
          .classed('linegraph_hoveritem', true)

        // Enter要素に対する初期値設定
        entered_hovers
          .attr('y', 0)
          .on('mouseover', this.onMouseOver)
          .on('mousemove', this.onMouseMove)
          .on('mouseout', this.onMouseOut)
        this.update_hoveritems(entered_hovers);


        // 不要要素の削除
        hovers.exit()
          .remove()

      },
      /**
       * hoveritemに値を設定する。
       * UpdateもEnterも同じ値を設定することになるので、functionとしてひとまとめにしてる。
       * @param elems
       */
      update_hoveritems(elems){
        elems
          .attr('x', (d) => {
            let year_index = this.get_years.indexOf(d);
            if( year_index === 0){
              return -this.offset.left / 2;
            }else{
              const prevYear = this.get_years[year_index - 1];
              let diff = d - (d - prevYear) / 2;
              return this.scale.x(diff)
            }
          })
          .attr('width', (d) =>{
            let year_index = this.get_years.indexOf(d);
            let left_pos = 0;
            let right_pos = 0;
            if( year_index === 0){
              left_pos = -this.offset.left / 2;
            }else{
              const prevYear = this.get_years[year_index - 1];
              let diff_prev = d - (d - prevYear) / 2;
              left_pos = this.scale.x(diff_prev)
            }

            if( year_index === this.get_years.length - 1){
              right_pos = this.get_grapharea_width() + this.offset.left - 20;
            }else{
              const nextYear = this.get_years[year_index + 1];
              let diff_next = d + (nextYear - d) / 2;
              right_pos = this.scale.x(diff_next)
            }
            //console.log( 'width', year_index, this.get_years, d, left_pos, right_pos);

            return right_pos - left_pos;
          })
          .attr('height',() => {
            return this.get_grapharea_height() + this.offset.top
          })
      },
      /**
       * hoveritem上にマウスをホバーした際のイベントハンドラ
       * @param d
       */
      onMouseOver(d){
        //console.log( 'mouseover', d);

        this.svg.selectAll('.linegraph_hoverlinegroup-'+d)
          .classed('linegraph_hoverlinegroup-active', true)

        this.svg.selectAll('.linegraph_circle-front.linegraph_circle-'+d)
          .classed('linegraph_circle-active', true)

        this.svg.selectAll('.linegraph_infotext-' + d)
          .classed('linegraph_infotext-active', true);

      },
     onMouseMove(d){
        // console.log( 'mousemove', d);
        this.svg.selectAll('g.linegraph_infotext')
          .attr('transform', (d) => {
            let x = 0, y = 0;
            let ev = window.event;

            x = this.scale.x(d.year);

            let loc_index = _.findIndex(this.selected.locations, (o) => {
              return o === d.location;
            })
            if( loc_index === -1){
              loc_index = this.selected.locations.length;
            }

            y = ev.clientY - 180 + (loc_index * 30);

            return 'translate(' + x + ', ' + y + ')';
          })

      },
      /**
       * hoveritem上からマウスをホバーアウトした際のイベントハンドラ
       * @param d
       */
      onMouseOut(d){
        //console.log( 'mouseout', d);

        this.svg.selectAll('.linegraph_hoverlinegroup-'+d)
          .classed('linegraph_hoverlinegroup-active', false)

        this.svg.selectAll('.linegraph_circle-'+d)
          .classed('linegraph_circle-active', false)

        this.svg.selectAll('.linegraph_infotext-' + d)
          .classed('linegraph_infotext-active', false);
      },
      /**
       * 複数生成される、add_hoverline()によって作られるホバー時表示要素をまとめるSVGグループを作る
       */
      add_hoverlines(){
        this.hoverlines = this.svg.append('g')
          .classed('linegraph_hoverlines', true)
          .attr('transform', 'translate(' + this.offset.left + ', ' + 0 + ')')
      },
      /**
       * マウスホバーした時に表示される、縦線とSelected Typeの表示を作る。
       */
      add_hoverline(){
        // データの付加
        let hovers = this.hoverlines.selectAll('g.linegraph_hoverlinegroup')
          .data(this.get_years)

        // Update要素
        this.update_hoverline_group(hovers);

        // // year text
        let hoverlineyeartexts = hovers.select('g.linegraph_hoverlineyeartext')
        this.update_hoverlineyeartext(hoverlineyeartexts);

        // // line
        let hoverlines = hovers.select('line')
        this.update_hoverline(hoverlines);

        // // text
        let hoverlinetexts = hovers.select('text.linegraph_hoverlinetext')
        this.update_hoverlinetext(hoverlinetexts);


        // Enter要素
        let entered_hovers = hovers.enter()

        let group_of_line_in_entered_hovers = entered_hovers.append('g')
        this.update_hoverline_group(group_of_line_in_entered_hovers);

        // // year text
        let group_of_year_text_in_entered_hoverlines =  group_of_line_in_entered_hovers.append('g')
          .attr('transform', () => {
            let x = 0, y = 9;
            y += this.get_grapharea_height() + this.offset.top;
            return 'translate('+ x + ', ' + y + ')';
          })
          .attr('class','linegraph_hoverlineyeartext')
        group_of_year_text_in_entered_hoverlines.append('rect')

        group_of_year_text_in_entered_hoverlines.append('text')
          .attr('dy', '0.71em')


        this.update_hoverlineyeartext(group_of_year_text_in_entered_hoverlines);


        // // line
        let group_of_line_in_entered_hoverlines =  group_of_line_in_entered_hovers.append('line')
          .attr('class','linegraph_hoverline')
        this.update_hoverline(group_of_line_in_entered_hoverlines);

        // // text
        let group_of_line_in_entered_hoverlinetexts = group_of_line_in_entered_hovers.append('text')
          .attr('transform', () => {
            let x = 0, y = 0;
            y = this.offset.top - 15;
            return 'translate('+ x + ', ' + y + ')';
          })
          .classed('linegraph_hoverlinetext', true)
        this.update_hoverlinetext(group_of_line_in_entered_hoverlinetexts);

        // // triangle path
        group_of_line_in_entered_hovers.append('path')
          .attr('d', 'M0,0H16L8,8')
          .attr('fill', '#fff')
          .attr('transform', () => {
            let x = 0, y = 0;
            x = -8;
            y = this.offset.top - 8;

            return 'translate('+ x + ', ' + y + ')';
          })

        // 不要要素
        hovers.exit()
          .remove()
      },
      /**
       * hoverlinegroupの値設定
       * UpdateとEnterとで共通の処理をまとめている
       */
      update_hoverline_group(elems) {
        elems
          .attr('class', (d) => {
            return 'linegraph_hoverlinegroup linegraph_hoverlinegroup-' + d
          })
          .attr('transform', (d) => {
            let x = 0, y = 0;
            x = this.scale.x(d);
            return 'translate('+ x + ', ' + y + ')';
          })

      },
      /**
       * hoverlineyeartextの値設定
       * UpdateとEnterとで共通の処理をまとめている
       */
      update_hoverlineyeartext(elems){
        // 位置調整
        elems
          .attr('transform', () => {
            let x = 0, y = 9;
            y += this.get_grapharea_height() + this.offset.top;
            return 'translate('+ x + ', ' + y + ')';
          })

        // テキスト内容調整
        elems
          .select('text')
          .text((d) => {
            return d;
          })

      },
      /**
       * hoverlineの値設定
       * UpdateとEnterとで共通の処理をまとめている
       */
      update_hoverline(elems){
        elems
          .attr('x1', 0)
          .attr('y1', this.offset.top)
          .attr('x2', 0)
          .attr('y2', this.get_grapharea_height() + this.offset.top)
      },
      /**
       * hoverlinetextの値設定
       * UpdateとEnterとで共通の処理をまとめている
       */
      update_hoverlinetext(elems){
        elems
          .text(/ja/.test(this.lang) ? this.selected.type.name : this.selected.type.label)
      },
      /**
       * グラフを描画する範囲のwidthを取得する。
       * 描画する範囲とは、目盛りの最低値〜最大値の範囲
       * @returns {number}
       */
      get_grapharea_width(){
        const cw = this.size.svg.width;
        return cw - this.offset.left - this.offset.right;
      },
      /**
       * グラフを描画する範囲のheightを取得する。
       * 描画する範囲とは、目盛りの最低値〜最大値の範囲
       * @returns {number}
       */
      get_grapharea_height(){
        const ch = this.size.svg.height - 80;
        return ch - this.offset.top - this.offset.bottom;
      },
      /**
       * Y軸目盛りの最大値となる値を計算し、取得する。
       * データ上の最大値では、最大目盛りの値が中途半端になってしまう問題への対処。
       * @returns {number}
       */
      get_adjustmentY(){
        const data = this.linegraph_data;
        let maxY = d3.max([].concat(data, [this.linegraph_japan_data]), (d) => {
          // d is array
          return d3.max( d, (d2) => {
            return Math.floor(d2.value);
          })
        })
        let digits = Math.pow(10, Math.min(4, String(maxY).length) - 1);
        let tmpY = maxY / digits;
        let ceilY = Math.ceil(tmpY);
        let adjustmentY = Math.max(ceilY * digits, 100);
        return adjustmentY;
      },
      /**
       * d3.jsのスケール変換メソッドの計算を行う。
       * データ上の最大値、最小値と、グラフを描画する範囲とを元に都度、定義を行う
       */
      set_scale(){
        let cw = this.get_grapharea_width();
        let ch = this.get_grapharea_height();

        this.scale.x = d3.scaleLinear()
          .domain([this.years[0], this.years[this.years.length - 1]])
          .range([0, cw])

        let adjustmentY = this.get_adjustmentY();

        this.scale.y = d3.scaleLinear()
          .domain([0, adjustmentY])
          .range([ch, 0])
      },
      /**
       * 一番初めのグラフ描画を行なう。
       * 具体的な値を表すものではなく、それらを入れるグループを生成する。
       */
      draw_graph(){
        //console.log( 'draw linegraph');

        this.linegraphs = this.svg.append('g')
          .classed('linegraph_linegraphs', true)
          .attr('transform', 'translate(' + this.offset.left + ', ' + this.offset.top + ')')
      },
      /**
       * 実際のグラフを描画する。グラフが示す値の更新もここで行われる。
       */
      update_graph(){
        // 折れ線グラフが表示されてないときは、グラフの再描画を行わない。
        if( this.selected.mode !== 'linegraph'){
          return;
        }

        // 折れ線を描いてくれるメソッドを定義。
        // scaleが変わるとメソッドも変わるので、都度初期化する。
        const d3line = d3.line()
          .x((d) => {
            return this.scale.x(d.year)
          })
          .y((d)=>{
            return this.scale.y(d.value);
          })

        // マウスホバーエリアの追加。UpdateやEnterなどは、この先で処理してくれている。
        this.add_hoveritems();

        // マウスホバー時に表示される縦線等の追加。UpdateやEnterなどは、この先で処理してくれている。
        this.add_hoverline();


        // 選択された都道府県とは別にJapanのデータも含めてグラフ描画する必要があるので、
        // 新しい配列を作って、Japan用データを末尾に追加している。
        let data = [].concat(this.linegraph_data);
        if( this.selected.alljapan ){
          data.push(this.linegraph_japan_data);
        }

        // データの付加
        let root = this.linegraphs.selectAll('g.linegraph_linegraph')
          .data(data, (d) => {
            //data()の第二引数は、新旧データの対応関係を指定するキーとなる値を指定するために用いる。
            //旧データの配列→新データの配列の順にすべてのデータが走査される
            //旧データが["Hokkaido","Japan","Tokyo"]、新データが["Hokkaido","Japan","Tokyo","Miyagi"]だと、
            //["Hokkaido","Japan","Tokyo","Hokkaido","Japan","Tokyo","Miyagi"]というふうに呼ばれる。
            const location = d[0].location;

            // Japan なら、 selected.locations内に無いので、固定値 100 を キーとして返す
            if( location === 'Japan'){
              return 100;
            }

            // dにloc_indexが登録されていないなら、追加分なのでselected.locations内のindexを計算する
            if(typeof d.loc_index === 'undefined'){
              let loc_index = _.findIndex(this.selected.locations, (o) => {
                return o === location;
              })
              d.loc_index = loc_index;
              return loc_index;
            }

            // Japanでもなく、d.loc_index が未定義でもないなら、 d.loc_indexの値をキーとして返す
            return d.loc_index;
          })


        // root の updates を更新
        this.update_linegraph_group(root);

        let line_in_updated_location = root.select('path.linegraph_line')
          .transition()
        this.update_linegraph_line(line_in_updated_location, d3line);


        /* InfoText */
        let info_in_updated_location = root.select('g.linegraph_info')

        let infotext_in_update_location = info_in_updated_location.selectAll('g')
          .data((row) => {
            //console.log( 'entered row data:', row);
            return row;
          })
        this.update_infotext_group(infotext_in_update_location);


        let locationText_in_update_location = infotext_in_update_location.select('text.linegraph_loctext')
        this.update_loctext(locationText_in_update_location);

        let valueText_in_update_location = infotext_in_update_location.select('text.linegraph_valtext')
        this.update_valuetext(valueText_in_update_location);


        // root の updates が持つ circle 用に data を更新
        let circle_in_updated_location = root.selectAll('circle')
          .data((row) => {
          //console.log( 'updated row data:', row);
          return row;
        })

        // updates circles のうち、update なcircleに対して、座標を更新
        let updated_circles = circle_in_updated_location
          .transition()
        this.update_circle(updated_circles);

        // updates circles のうち、 enter な circle を生成
        let entered_circles = circle_in_updated_location.enter()
          .append('circle')
        this.update_circle(entered_circles);

        // updates circles のうち、 不要になったものを削除
        circle_in_updated_location.exit()
          .remove()



        /* **********************************************
         *
         * 新規に追加された locatoin
         *
         *********************************************** */

        let entered_location = root.enter()
          .append('g')
          .classed('linegraph_linegraph', true)
        this.update_linegraph_group(entered_location);


        /* Line */
        let line_in_entered_location = entered_location.append('path')
        this.update_linegraph_line(line_in_entered_location, d3line);


        /* InfoText */
        let info_in_entered_location = entered_location.append('g')
          .classed('linegraph_info', true)

        let infotext = info_in_entered_location.selectAll('g')
          .data((row) => {
            //console.log( 'entered row data:', row);
            return row;
          })
          .enter()
          .append('g')
        this.update_infotext_group(infotext);


        let locationText = infotext.append('text')
        this.update_loctext(locationText);

        let valueText = infotext.append('text')
        this.update_valuetext(valueText);



        /* Circle */
        let circles_in_entered_location = entered_location.append('g')
          .classed('linegraph_circles', true)

        // 新規に追加された location に、内包するcircle用データを突っ込む
        let circle_in_entered_location = circles_in_entered_location.selectAll('circle')
          .data((row) => {
            //console.log( 'entered row data:', row);
            return row;
          })

        // 新規に追加された location 用 circle の設定。
        // 新規に追加された location 用 circle に update は存在しない
        let appended_circles = circle_in_entered_location.enter()
          .append('circle')
        this.update_circle(appended_circles);


        // 不要になった location を削除
        root.exit()
          .remove();


        /* **********************************************
         *
         * すべての要素に更新を
         *
         *********************************************** */
        this.svg.selectAll('g.linegraph_infotext')
          .attr('transform', (d) => {
            let x = 0, y = 0;
            x = this.scale.x(d.year);

            let min_value = d3.min(data, (d2) => {
              //console.log('d2', d2);
              let min_value_2 = d3.min(d2, (d3) => {
                return parseFloat(d3.value);
              });
              return min_value_2;
            })

            let loc_index = _.findIndex(this.selected.locations, (o) => {
              return o === d.location;
            })
            if( loc_index === -1){
              loc_index = this.selected.locations.length;
            }

            y = this.scale.y(min_value) + 50 + 30 * loc_index;
            //console.log('infotext', x, y, min_value, loc_index, d.location)

            return 'translate(' + x + ', ' + y + ')';
          })


        // 軸線の更新
        this.axis.x
          .transition()
          .attr('transform', 'translate(' + this.offset.left + ',' + ( this.get_grapharea_height() + this.offset.top )+ ')')
          .call(this.axis.helper.x
            .scale(this.scale.x)
            //.tickValues(this.get_years)
            .tickValues( this.get_years.filter((value) => {
              return value % 5 === 0
            }))

          )
        this.axis.y
          .transition()
          .call(this.axis.helper.y
            .scale(this.scale.y)
            .tickSize(- (this.size.svg.width - 20 - 20))
          )
      },
      /**
       * 各ロケーションの折れ線グラフをくるむsvgグループのUpdate/Enter処理
       * @param elems
       */
      update_linegraph_group(elems){
        elems
          .attr('data-location', (d) => {
            //console.log( 'entered g.linegraph_linegraph data: ', d)
            return d[0].location;
          })
      },
      /**
       * 各ロケーションの折れ線自体を更新する
       * @param elems
       */
      update_linegraph_line(elems, d3line){
        elems
          .attr('class', (d) => {
            let classed = 'linegraph_line';

            let loc_index = _.findIndex(this.selected.locations, (o) => {
              return o === d[0].location;
            })
            if( loc_index === 0){
              classed += ' linegraph_line-front'
            }else if( loc_index === -1){
              classed += ' linegraph_line-japan'
            }

            return classed;
          })
          .attr('d', d3line)
          .attr('stroke', (d)=>{
            //console.log( 'stroke', d[0], this.selected.locations);
            const loc = d[0].location;
            let loc_index = _.findIndex(this.selected.locations, (o) => {
              //console.log( 'loc_index', o, loc);
              return o === loc;
            })
            //console.log(loc_index);
            if( loc_index === -1){
              return "#" + this.linegraph_japan_color;
            }else{
              return "#" + this.linegraph_color[loc_index];
            }
          })
      },
      /**
       * ホバー時に表示される地名と値とを、くるむグループの更新
       * @param elems
       */
      update_infotext_group(elems){
        elems
          .attr('class', (d) => {
            return 'linegraph_infotext linegraph_infotext-' + d.year;
          })
      },
      /**
       * infotextグループ内の、地名表示の更新
       * @param elems
       */
      update_loctext(elems){
        elems
          .attr('class', (d) => {
            const loc = d.location;
            let classed = 'linegraph_loctext';

            let loc_index = _.findIndex(this.selected.locations, (o) => {
              return o === loc;
            })
            if( loc_index === 0){
              classed += ' linegraph_loctext-front'
            }

            if( _.last(this.get_years) === parseInt(d.year) ){
              classed += ' linegraph_loctext-last'
            }

            return classed;
          })
          .text((d) => {
            let pref = this.get_location_data(d.location);
            return /ja/.test(this.lang) ? pref.properties.name_local : pref.properties.name;
          })
          .attr('fill', (d)=>{
            //console.log( 'stroke', d);
            const loc = d.location;
            let loc_index = _.findIndex(this.selected.locations, (o) => {
              return o === loc;
            })
            //console.log(loc_index);
            if( loc_index === -1){
              return "#" + this.linegraph_japan_color;
            }else{
              return "#" + this.linegraph_color[loc_index];
            }
          })
      },
      /**
       * infotextグループ内の、値表示の更新
       * @param elems
       */
      update_valuetext(elems){
        elems
          .attr('class', (d) => {
            const loc = d.location;
            let classed = 'linegraph_valtext';

            let loc_index = _.findIndex(this.selected.locations, (o) => {
              return o === loc;
            })
            if( loc_index === 0){
              classed += ' linegraph_valtext-front'
            }

            if( _.last(this.get_years) === parseInt(d.year) ){
              classed += ' linegraph_valtext-last'
            }
            return classed;
          })
          .text((d) => {
            if( /Life_expectancy/.test(this.selected.type.value) || /HALE/.test(this.selected.type.value)){
              return d3.format(".1f")(d.value);
            }else{
              return d3.format(".3f")(d.value);
            }
          })
          .attr('fill', (d)=>{
            //console.log( 'stroke', d);
            const loc = d.location;
            let loc_index = _.findIndex(this.selected.locations, (o) => {
              return o === loc;
            })
            //console.log(loc_index);
            if( loc_index === -1){
              return "#" + this.linegraph_japan_color;
            }else{
              return "#" + this.linegraph_color[loc_index];
            }
          })
      },
      /**
       * 折れ線グラフの点の更新
       * @param elems
       */
      update_circle(elems){
        elems
          .attr('class', (d) => {
            const loc = d.location;
            let classed = 'linegraph_circle linegraph_circle-' + d.year;

            let loc_index = _.findIndex(this.selected.locations, (o) => {
              return o === loc;
            })
            if( loc_index === 0){
              classed += ' linegraph_circle-front'
            }else if( loc_index === -1){
              classed += ' linegraph_circle-japan'
            }

            return classed;
          })
          .attr('cx',(d)=>{
            return this.scale.x(d.year);
          })
          .attr('cy',(d)=>{
            return this.scale.y(d.value);
          })
          .attr('fill', (d)=>{
            //console.log( 'stroke', d);
            const loc = d.location;
            let loc_index = _.findIndex(this.selected.locations, (o) => {
              return o === loc;
            })
            //console.log(loc_index);
            if( loc_index === -1){
              return "#" + this.linegraph_japan_color;
            }else{
              return "#" + this.linegraph_color[loc_index];
            }
          })
      }
    }

  }
</script>
<style lang="sass">
  .linegraph
    background-color: #000
    color: #fff
    height: 100%
    &_svgwrapper
      height: 100%
    &_svg
      height: 100%
      width: 100%
    &_axis
      pointer-events: none
      .domain
        stroke: none
      .tick
        line
          stroke: #666666
        text
          fill: #fff
      &_x
        .tick
          text
            font-size: 14px

      &_y
        .tick
          line
          text
            transform: translate(5px, -10px)
            text-anchor: start
            font-size: 10px
    &_line
      fill: none
      stroke-width: 4
      &-front
        stroke-width: 6
      &-japan
        stroke-width: 2

    &_linegraphs
      pointer-events: none

    &_info
    &_infotext
      opacity: 0
      transition: opacity .1s linear
      &-active
        opacity: 1
    &_loctext
      font-size: 12px
      text-anchor: end
      transform: translate(-10px, 0)
      &-front
        font-size: 14px
      &-last
        text-anchor: start
        transform: translate(10px, 0)
    &_valtext
      font-size: 20px
      font-weight: bold
      transform: translate(10px, 0)
      &-front
        font-size: 30px
      &-last
        text-anchor: end
        transform: translate(-10px, 0)

    &_circles
    &_circle
      r: 7.5
      transition: r .1s linear, stroke .1s linear, stroke-width .1s linear
      &-front
        r: 10
      &-japan
        r: 4
      &-active
        fill: #000
        stroke: #fff
        r: 10.5
        stroke-width: 3


    &_hoverarea
    &_hoveritem
      fill: transparent
    &_hoverlines
    &_hoverlinegroup
      opacity: 0
      transition: opacity .1s linear
      pointer-events: none
      &-active
        opacity: 1
    &_hoverlineyeartext
      text
        fill: #fff
        font-size: 14px
        font-weight: bold
        text-anchor: middle
        font-family: sans-serif
      rect
        x: -24
        y: -6
        width: 50px
        height: 20px
        fill: #000
    &_hoverline
      stroke: #fff
      stroke-width: 1
    &_hoverlinetext
      fill: #fff
      font-size: 14px
      text-anchor: middle


</style>